"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingRuleComplementaryByCategory = void 0;
const _1 = require("./");
const PricingRuleComplementary_1 = require("./PricingRuleComplementary");
/**
 * Pricing Rule: ComplementaryByCategory
 *
 * This rule defines the maximum number of items in a specified category
 * a customer can have for free. For example, a burrito product
 * blueprint (base price $12.40) comes with a protein category with three
 * options (unit price $2.50), beef, pork and lamb. It also comes with a
 * ComplementaryByCategory pricing rule on the protein category saying the
 * complementary quantity is 1. Given such a blueprint, it would cost $12.40
 * which is the base price if the customer chose beef as the main protein and
 * didn’t add any extra protein. It would still cost $12.40 the base price
 * if the customer chose beef as the main protein and added an extra share of
 * beef as it didn’t exceed the complementary quantity this pricing rule had
 * on the protein category, i.e. the first extra share of protein is free.
 * On the other hand, it would cost $14.90, the base price plus the unit price
 * for an extra share of protein if the customer chose beef as the main protein
 * and added two extra shares of pork as it exceeded the complementary quantity
 * this pricing rule had on the protein category by 1, hence the extra charge
 * of $2.50.
 */
class PricingRuleComplementaryByCategory extends PricingRuleComplementary_1.PricingRuleComplementary {
    constructor(data) {
        super(data);
        this.name = _1.TPricingRuleName.complementaryByCategory;
        if (data) {
            this.category = data.category;
        }
    }
    serialize() {
        return Object.assign(Object.assign({}, super.serialize()), { category: this.category });
    }
    static unserialize(data) {
        const newPricingRuleComplementaryByCategory = new this();
        newPricingRuleComplementaryByCategory.category = data.category;
        newPricingRuleComplementaryByCategory.quantity = data.quantity;
        return newPricingRuleComplementaryByCategory;
    }
    calculateDiscount(productAvailability, selectedProducts) {
        const quantityInCategory = this.getQuantityForCategory(selectedProducts);
        const applicableQuantity = Math.min(quantityInCategory, this.quantity);
        const discountPrice = this.getDiscountPrice(selectedProducts);
        const discount = applicableQuantity * discountPrice;
        return discount;
    }
    /**
     * Check that the given product category matches this category pricing rule
     */
    matchesPricingRule(product) {
        return product.category.name === this.category;
    }
    /**
     * Get the total number of all products in the category specified by the pricing rule.
     */
    getQuantityForCategory(selectedProducts) {
        const selectedInCategory = selectedProducts.filter(p => p.product.category.name === this.category);
        const quantity = selectedInCategory.reduce((total, current) => total + current.quantity, 0);
        return quantity;
    }
    /**
     * Determine the discount unit price based on selected products.
     */
    getDiscountPrice(selectedProducts) {
        let discountPrice = 0;
        const selectedInCategory = selectedProducts.filter(p => p.product.category.name === this.category);
        if (selectedInCategory.length > 0) {
            // Sort by price high -> low,
            // then use the first prooduct's retail price as the discount price.
            // HACK assumes all items are priced the same way, otherise it would
            // be the highest retail price. We can be generous, however this logic
            // could be exploited by customers.
            discountPrice = selectedInCategory.sort((pa, pb) => pb.product.retailPrice - pa.product.retailPrice)[0].product.retailPrice;
        }
        return discountPrice;
    }
}
exports.PricingRuleComplementaryByCategory = PricingRuleComplementaryByCategory;
//# sourceMappingURL=PricingRuleComplementaryByCategory.js.map